var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.homeEditReady)?_c('section',[(_vm.home_edit_html)?_c('section',{staticClass:"interHome-custom",domProps:{"innerHTML":_vm._s(_vm.home_edit_html)}}):_c('Custom')],1):_vm._e(),(_vm.headerSymbol.length)?_c('Recommend',{attrs:{"dataList":_vm.recommendDataList}}):_vm._e(),(!_vm.baseInfo)?_c('i'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }